const el = document.createElement('div');

function polyfill(eventNames) {
  for (const name in eventNames) {
    if (el.style[name] !== undefined) {
      return eventNames[name];
    }
  }

  return false // ie8 etc.
}

export const animationEnd = polyfill({
  msAnimation     : 'MSAnimationEnd',
  WebkitAnimation : 'webkitAnimationEnd',
  MozAnimation    : 'animationend',
  OAnimation      : 'oAnimationEnd oanimationend',
  animation       : 'animationend'
});

export const transitionEnd = polyfill({
  msTransition     : 'MSTransitionEnd',
  WebkitTransition : 'webkitTransitionEnd',
  MozTransition    : 'transitionend',
  OTransition      : 'oTransitionEnd otransitionend',
  transition       : 'transitionend'
});

export const subscribe = (element,events,callback,...args)=>{
  events = Array.isArray(events) ? events : events.split(' ');
  events.forEach(event => element.addEventListener(event,callback,...args));
  return ()=>{
    events.forEach(event => element.removeEventListener(event,callback));
  }
}

export const dispatch = (element,name,detail={},bubbles=true,cancelable=true)=>{
  const event = new CustomEvent(
    name,
    {
        detail,
        bubbles,
        cancelable
    }
  );

  element.dispatchEvent(event);
  /*if(process.env.NODE_ENV === 'development'){
    console.log(`%c${name}`,'color:#0088ff');
  }*/

  return event;
}